import { useEffect } from 'react';
import { useAppSelector } from '../../../hooks';

import { selectFeatureFlags, selectFreeFormQuery } from 'reducers/workflows';
import { scrollToTheBottom } from 'utils/helpers';

// This will prevent input box from getting cut off while typing:
const useScrollToBottomOnFreeFormQueryChange = () => {
  const freeFormQuery = useAppSelector(selectFreeFormQuery);
  const featureFlags = useAppSelector(selectFeatureFlags);
  const isDisabled = featureFlags.includes(
    'solve_ui_disable_scroll_to_bottom_on_free_form_query_change',
  );

  // This is a workaround that had to be added after implementing the tabs.
  // Without it, it doesn't scroll to the very bottom (a few pixels short).
  // A 50ms timeout is necessary.
  useEffect(() => {
    setTimeout(() => {
      scrollToTheBottom('smooth');
    }, 50);
  }, []);

  useEffect(() => {
    if (isDisabled) {
      return;
    }

    // `setTimeout()` is necessary.
    // Not sure why, but without it, the scrolling happens BEFORE the input box
    // height increases. Maybe the height increase happens asynchronously as
    // well.
    setTimeout(() => {
      scrollToTheBottom('instant'); // `instant` has better UX in this case
    }, 0);
  }, [freeFormQuery, isDisabled]);
};

export default useScrollToBottomOnFreeFormQueryChange;
